import React, { useState, useEffect, useContext } from 'react'
import { SaveAlt } from '@material-ui/icons'
// import AllSections from '../../../Search/EmailListsSummary/GetSummarySections'
// import { getFormattedNumber } from '../../../../PropertyList/Utility/PropertyListUtility'
import { downloadcsv } from '../../../Services'

export default function DownloadEmailList(props) {

    const { list, closeModal , count } = props
    const [downloadClicked, setDownloadClicked] = useState(false)
    const [postalCardDownloadClicked, setPostalCardDownloadClicked] = useState(false)
    const [sections, setSections] = useState([])
    // const listType = list.listType == 'Not Specified' ? 'property' : list.listType
    // const sections = AllSections.filter(col => col.listType.includes(listType))

    useEffect(() => {
        // console.log('list = ', JSON.stringify(list))
        getSections()
    }, [list])

    useEffect(() => {
        if (downloadClicked) {
            handleDownload()
        }
    }, [downloadClicked])

    useEffect(() => {
        if (postalCardDownloadClicked) {
            handlePostalCardDownload()
        }
    }, [postalCardDownloadClicked])
    const contactTypesMapping = {

        'mailableContact': 'Mailable Contacts',
        'nonMailableContact': 'Non Mailable Contacts',
        'optedOut': 'Opted Out',
        'propertyOwner': 'Property Owners',
        'propertySeller': 'Property Sellers',
        'interestedBuyer': 'Interested Buyers',
        'brokerContacts': 'Broker Contacts',
        'unique': 'Unique',
    };

    const handlePostalCardDownload = async () => {
        try {
            let view = []

            sections.forEach(element => {
                if (element.isChecked) {
                    view.push(element.view)
                }
            });

            if (view.length === 0) {
                view = ['mailableContact', 'nonMailableContact', 'optedOut', 'propertyOwner',
                    'propertySeller', 'interestedBuyer'
                ]
            }

            let payload = {
                polarisEmailListId: list.polarisEmailListId,
                "postalMailingContacts": true,
                recordStatus: list.recordStatus
            }

            let response = await downloadcsv(payload)
            setPostalCardDownloadClicked(false)

            if (response.data) {
                let blob;
                let link = document.createElement("a")
                link.href = 'data:text/csv;charset=utf-8,' + response.data
                link.target = '_blank'
                let listName = list.listName
                listName = listName.replace(/[\W_]+/g, " ")
                listName = listName.trim()
                listName = listName.substring(0, 200)
                link.download = `${listName}.csv`
                link.click()
            }
            closeModal()
        }
        catch (e) {
            console.log('Error handleDownload:: ', e)
        }
    }
    const handleDownload = async () => {
        try {
            let view = []

            sections.forEach(element => {
                if (element.isChecked) {
                    view.push(element.view)
                }
            });

            if (view.length === 0) {
                view = ['mailableContact', 'nonMailableContact', 'optedOut', 'propertyOwner',
                    'propertySeller', 'interestedBuyer'
                ]
            }

            let payload = {
                polarisEmailListId: list.polarisEmailListId,
                view,
                recordStatus: list.recordStatus
            }

            // const header = { 'Content-Type': 'application/x-www-form-urlencoded' }
            // const getCountRslt = await APIInterceptor(emailListAPIs.getSummaryCount, criteriaPayload, header)
            let response = await downloadcsv(payload)
            setDownloadClicked(false)
            // console.log('response = ', response)

            if (response.data) {
                let blob;
                // blob = window.atob(response.data)
                let link = document.createElement("a")
                link.href = 'data:text/csv;charset=utf-8,' + response.data
                link.target = '_blank'
                let listName = list.listName
                listName = listName.replace(/[\W_]+/g, " ")
                listName = listName.trim()
                listName = listName.substring(0, 200)
                link.download = `${listName}.csv`
                link.click()
            }

            // if (response.data) {
            //     let blob;
            //     blob = window.atob(response.data)
            //     let link = document.createElement("a")
            //     link.href = 'data:text/csv;charset=utf-8,' + encodeURI(blob)
            //     link.target = '_blank'
            //     let listName = list.listName
            //     listName = listName.replace(/[\W_]+/g, " ")
            //     listName = listName.trim()
            //     listName = listName.substring(0, 200)
            //     link.download = `${listName}.csv`
            //     link.click()
            // }

            closeModal()
            // let response = 'Y29udGFjdElkLEZpcnN0IE5hbWUsTGFzdCBOYW1lLEVtYWlsLEFjY291bnQgTmFtZQoiSm9zZXBoIiwiS3VlbmVtYW4iLCIwMDMwYzAwMDAyY29uYkhBQVEiCiJKb2VsIiwiS2F0eiIsIjAwMzMwMDAwMDFMbGV2WEFBUiIKIk1vbGxpZSIsIkRpZXRzY2giLCIwMDMzMDAwMDAxTGxldk9BQVIiCiJNYXR0IiwiRm9zdGVyIiwiMDAzMzAwMDAwMUxsZXdhQUFCIgoiSm9obiIsIkVhcm5oYXJ0IiwiMDAzMzAwMDAwMUxsZXZkQUFCIgoiUGhpbCIsIkZyaWRkIiwiMDAzMzAwMDAwMUxsZXdoQUFCIgoiSm9obiIsIkhhbGwiLCIwMDMzMDAwMDAxTGxleFdBQVIiCiJKYW1lcyIsIkhhd2tpbnMiLCIwMDMzMDAwMDAxTGxleG1BQUIiCiJCbyIsIkhhdmxpayIsIjAwMzMwMDAwMDFMbGV4bEFBQiIKIiIsIkpvbmVzIiwiMDAzMzAwMDAwMUxsZXowQUFCIgo='

        }
        catch (e) {
            console.log('Error handleDownload:: ', e)
        }
    }

    const getSections = () => {
        let returnValue = []
        Object.keys(list.summary).map(function (keyName, keyIndex) {
            returnValue.push({
                view: keyName,
                count: list.summary[keyName],
                isChecked: false,
                isDisabled: list.summary[keyName] == 0 ? true : false,
            })
        })

        setSections(returnValue)
    }

    const handleClick = item => {
        if (item.count === 0) { return }

        let i = sections.findIndex(x => x.view === item.view)
        let newSections = [...sections]
        newSections[i].isChecked = !newSections[i].isChecked
        setSections(newSections)
    }

    const isDownloadAll = () => {
        let returnValue = true

        sections.forEach(element => {
            if (element.isChecked) {
                returnValue = false
            }
        });

        return returnValue
    }

    const isDisabled = () => {
        let returnValue = true

        sections.forEach(element => {
            if (element.count !== 0) {
                returnValue = false
            }
        });

        return returnValue
    }

    return (
        <>
            <div data-testid="test-div-container-download-email-list" className='flex flex-col py-4 gap-4 drawer-w-download'>
                <div className='flex flex-row border-b-1 border-base px-4 pb-2 items-center'>
                    <span className='pb-4'>
                        <SaveAlt fontSize="small" />
                    </span>
                    <span className='px-2'> Download Email list </span>
                </div>
                <div className="p-4">
                    {sections && sections.map((val, index) =>
                        <>
                            {
                                val.view !== 'unique' && val.view !== 'brokerContacts' && val.view !== 'clientPreferencesDoNotMatch' ? <div data-testid={`test-badge-${val.view}`} onClick={() => handleClick(val)}
                                    className={`badge rounded-pill py-3 px-5 mr-3 mb-4 cursor-pointer ${val.isChecked ? 'text-white bg-primary' : 'text-primary bg-blue-10'}`}>
                                    {`${contactTypesMapping[val.view]} : ${val.count}`}
                                </div>
                                    : null
                            }
                        </>
                    )}
                </div>
                {/* <div className='py-2 px-4'>
                    To reflect the correct contacts count as per the applied filters, please save / update the list first
                </div> */}
                <div data-testid='test-download-emaillist' className='py-2 px-4'>
                    <div className='flex justify-end space-x-4 mt-auto'>
                        <div>
                            <button data-testid='test-button-cancel' onClick={props.closeModal} className='btn btn-sm' type='button'>Close</button>
                        </div>
                        <div>
                            {postalCardDownloadClicked ?
                                <button className="btn btn-sm btn-primary c-disabled">
                                    <span className="loader h-5 w-5 mx-2" ></span>
                                    <span className="px-2">Downloading</span>
                                </button>
                                :
                                <button data-testid='test-button-download-email-list' disabled={isDisabled()} hidden={!isDownloadAll()}
                                    onClick={() => { setPostalCardDownloadClicked(true) }}
                                    className='btn btn-sm btn-primary'>
                                    {`${isDownloadAll() ? `Download all postcard mailing contacts: ${count}` : ''}`}
                                </button>
                            }
                        </div>
                        <div>
                            {downloadClicked ?
                                <button className="btn btn-sm btn-primary c-disabled">
                                    <span className="loader h-5 w-5 mx-2" ></span>
                                    <span className="px-2">Downloading</span>
                                </button>
                                :
                                <button data-testid='test-button-download-email-list' disabled={isDisabled()}
                                    onClick={() => { setDownloadClicked(true) }}
                                    className='btn btn-sm btn-primary'>
                                    {`${isDownloadAll() ? 'Download all unique contacts' : 'Download selected contacts'}`}
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
